export const backgroundScenesHelper = {
  firstBlueRoom: 400,
  firstPinkRoom: 235,
  second: 1445,
  third: 1445,
  forth: 1445,
  fifth: 1445,

  get secondScenePositionX() {
    return this.firstBlueRoom + this.firstPinkRoom;
  },

  get thirdScenePositionX() {
    return this.secondScenePositionX + this.second;
  },

  get forthScenePositionX() {
    return this.thirdScenePositionX + this.third;
  },

  get fifthScenePositionX() {
    return this.forthScenePositionX + this.forth;
  },
};
